<template>
  <b-card
    no-body
    class="card-developer-meetup"
  >
    <b-card-header class="mb-3">
      <b-card-title>
        {{ $t('Recent Activities') }}
      </b-card-title>

      <feather-icon
        icon="RotateCwIcon"
        class="cursor-pointer"
        @click="fetchRecentActivities"
      />
    </b-card-header>

    <b-card-body>
      <app-timeline
        v-for="(activity, activityIndex) in recentActivities"
        :key="activityIndex"
      >
        <app-timeline-item
          :title="$t(activity.title)"
          :subtitle="$t(activity.subtitle)"
          :time="activity.time"
          :variant="activity.variant"
        />
      </app-timeline>
      <div class="text-center">
        <Button
          v-if="!isLoadingRecentActivities && recentActivities.length && getUserPermission('AUDIT_TRAIL')"
          :label="$t('View All')"
          class="mt-4"
          size="md"
          @click="goToAuditTrail"
        />
      </div>
    </b-card-body>
    <Spinner :show="isLoadingRecentActivities" />
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, VBTooltip, BCardHeader, BCardTitle,
} from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import Ripple from 'vue-ripple-directive'
import { onMounted, ref } from '@vue/composition-api'
import { useActions } from 'vuex-composition-helpers'
import { permissionMixin } from '@core/mixins/permission'
import Button from '../../components/button/Button.vue'
import Spinner from '@/views/components/spinner/Spinner.vue'
import { toDateWithTime } from '../../../helpers/formatDate'
import useToastAlert from '../../../composable/useToast'

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    BCardTitle,
    Button,
    AppTimeline,
    AppTimelineItem,
    Spinner,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mixins: [permissionMixin],
  methods: {
    goToAuditTrail() {
      this.$router.push({ name: 'audit-trail' })
    },
  },
  setup() {
    const { getRecentActivities } = useActions({ getRecentActivities: 'dashboard/getRecentActivities' })
    const { toastAlert } = useToastAlert()
    const recentActivities = ref([])
    const isLoadingRecentActivities = ref(false)

    const fetchRecentActivities = async () => {
      try {
        isLoadingRecentActivities.value = true
        const response = await getRecentActivities()

        const { status, data } = response
        if (status === 200 && data) {
          recentActivities.value = data.map(item => {
            const time = toDateWithTime(item.dateCreated).split(' ')
            return {
              title: item.entity,
              subtitle: item.dataOperationType,
              time: `${time[1]} ${time[2]}`,
              variant: 'primary',
            }
          }).slice(0, 5)

          isLoadingRecentActivities.value = false
        }
      } catch (err) {
        toastAlert(err)
      } finally {
        isLoadingRecentActivities.value = false
      }
    }

    onMounted(() => {
      fetchRecentActivities()
    })

    return {
      recentActivities,
      isLoadingRecentActivities,
      fetchRecentActivities,
    }
  },

}
</script>
